import React from 'react'

import {
  PATHNAME,
  SIGNIN_USER,
  SIGNOUT_USER,
  INIT_URL,
} from '../constants/ActionTypes'

import {
  urlLogin
} from '../util/globals';
import { fetchAsync } from '../util/fetchers';

export default (state, dispatch) => ({
  /**
  * GENERAL ACTIONS
  */

  userSignIn: (values) => {
    return fetchAsync(urlLogin, JSON.stringify(values), "POST", "")
      .then((response) => {
        if (response.success) {
          dispatch({ type: SIGNIN_USER, payload: { success: true, response } });
        } else {
          dispatch({ type: 'ERROR', payload: { ...response } });
        }
        return response;
      }).catch((reason) => {
        console.log(reason.message);
      });
    // 
  },

  userSignOut: () => {
    dispatch({ type: SIGNOUT_USER, payload: { success: true } });
  },

  setInitUrl: (url) => {
    dispatch({ type: INIT_URL, payload: { success: true, url } });
  },

  setPathname: (pathname) => {
    dispatch({ type: PATHNAME, payload: { success: true, pathname } });
  },

});
